import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import rail from "../../Assets/Projects/rail.png";
import Quiz from "../../Assets/Projects/Quiz.png";
import newss from "../../Assets/Projects/newss.png";
import chatify from "../../Assets/Projects/chatify.png";
import pFood from "../../Assets/Projects/pFood.png";
import todo from "../../Assets/Projects/todo.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={rail}
              title="Rail Sathi"
              description="RailSathi is an API-based web application built with Express.js and Node.js that allows users to check PNR status and find trains between stations. It provides a convenient way for users to access essential railway information quickly and efficiently. It simplifies the process of planning train travel by offering real-time updates and seamless access to railway data."
              ghLink="https://github.com/pratikkhulge/RailSathi"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Quiz}
              title="Quiz Bolt"
              description="Quiz Bolt is an API-first web application offering users a versatile platform to engage in quizzes across diverse fields. Users can enjoy interactive quizzes tailored to their interests, spanning topics such as science, history, technology, and offers multiple difficulty levels, including multiple-choice and true/false formats."
              ghLink="https://github.com/pratikkhulge/QuizBolt"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={newss}
              title="Newss"
              description="Newss is a prototype web application built on an API platform, allowing users to access news from various countries, in different languages, and covering diverse topics, offering a comprehensive and customizable news reading experience."
              ghLink="https://github.com/pratikkhulge/Newss"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={todo}
              title="Task-Manager"
              description="Task-Management is a modern web application built using React.js and Firebase, designed to streamline task management with ease. Users can effortlessly create, edit, and mark tasks as complete, all while enjoying the security of Firebase authentication, ensuring each user's data remains private and accessible only to them."
              ghLink="https://github.com/pratikkhulge/Task_Manager_Todo"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={pFood}
              title="pFood"
              // description="pFood is a dynamic web application designed to enhance the dining experience. With a sleek and modern design, it offers a seamless browsing experience enriched with captivating animations and stylish elements. From browsing the menu to making reservations, pFood provides users with a visually appealing interface that makes exploring and interacting with the website a delight. Whether you're looking for a quick bite or planning a special dining occasion ."
              description="pFood is a dynamic web application with a sleek design and captivating animations, offering seamless browsing and reservation experiences. Whether it's a quick bite or a special dining occasion, explore menus and make reservations effortlessly."
              ghLink="https://github.com/pratikkhulge/pFood"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chatify}
              title="Chat Application"
              // description="The prototype chat web application utilizes local storage to store chat messages and supports interaction between two different users. Users can log in with unique credentials to access the chat interface where they can send and receive messages in real-time. The application's design focuses on simplicity and ease of use, allowing users to engage in private conversations securely within their browser environment without the need for a centralized server."
              description="
              The chat web app prototype enables secure, real-time messaging between two users. Utilizing local storage, it stores chat messages locally, ensuring privacy and eliminating the need for a centralized server."
              ghLink="https://github.com/pratikkhulge/ChatApplication"
            />
          </Col>

          {/* <Col md={4} className="project-card">
            <ProjectCard
              imgPath={calculator}
              isBlog={false}
              title="The Binary Calculator"
              description="The Binary Calculator Tkinter application is a Python program built using the Tkinter library, allowing users to perform basic arithmetic operations on binary numbers. It provides a user-friendly graphical interface where users can input binary numbers and perform addition, subtraction, multiplication, and division operations. The application accurately processes binary calculations and displays the results in binary format, offering a convenient tool for working with binary numbers."
              ghLink="https://github.com/pratikkhulge/Binary-Calculator-Tkinter"
            />
          </Col> */}
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
